module.exports = __webpack_public_path__ + "img/workshops.f6e05947.svg";